export default function WeighingScale({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
      <path
        fill="#9bb9c3"
        d="M444.96 502.04H67.04a15 15 0 0 1-15-15v-32.86h407.92v32.86a15 15 0 0 1-15 15z"
      />
      <path
        fill="#87a0af"
        d="M429.96 454.18v32.86a15 15 0 0 1-15 15h30a15 15 0 0 0 15-15v-32.86z"
      />
      <path fill="#9bb9c3" d="M75 166.56h46.3v270.17H75z" />
      <circle cx="98.14" cy="92.01" r="82.05" fill="#e1ebf0" />
      <circle
        cx="98.14"
        cy="92.01"
        r="54.32"
        fill="#fdfcfc"
        transform="rotate(-45.01 98.13 92.04)"
      />
      <path
        fill="#f1f1f1"
        d="M98.14 37.69c-5.2 0-10.23.74-15 2.11a54.34 54.34 0 0 1 0 104.42 54.31 54.31 0 0 0 69.33-52.2c0-30.01-24.32-54.33-54.33-54.33z"
      />
      <path
        fill="#e1ebf0"
        d="M492.17 470.43H19.83c-6.81 0-12.33-5.52-12.33-12.33v-9.04c0-6.8 5.52-12.33 12.33-12.33h472.34c6.81 0 12.33 5.52 12.33 12.33v9.04c0 6.81-5.52 12.33-12.33 12.33z"
      />
      <path
        fill="#fdd17a"
        d="M387.94 299.5h-151.6V177.61a15 15 0 0 1 15-15h121.6a15 15 0 0 1 15 15z"
      />
      <path
        fill="#e59a69"
        d="M336.7 162.61v23.94c0 9.85-7.98 17.83-17.83 17.83H305.4a17.82 17.82 0 0 1-17.82-17.83v-23.94"
      />
      <path
        fill="#fdd17a"
        d="M312.13 436.39h-136.6a15 15 0 0 1-15-15V314.5a15 15 0 0 1 15-15h136.6zM448.75 436.44h-136.6V299.55h136.6a15 15 0 0 1 15 15v106.89a15 15 0 0 1-15 15z"
      />
      <path
        fill="#b4d2d7"
        d="M492.17 436.73h-30c6.81 0 12.33 5.52 12.33 12.33v9.04c0 6.81-5.52 12.33-12.33 12.33h30c6.81 0 12.33-5.52 12.33-12.33v-9.04c0-6.8-5.52-12.33-12.33-12.33z"
      />
      <g fill="#ebc272">
        <path d="M372.94 162.61h-30a15 15 0 0 1 15 15V299.5h30V177.61a15 15 0 0 0-15-15zM282.13 299.5h30v136.89h-30zM448.75 299.55h-30a15 15 0 0 1 15 15v106.89a15 15 0 0 1-15 15h30a15 15 0 0 0 15-15V314.55a15 15 0 0 0-15-15z" />
      </g>
      <path
        fill="#e59a69"
        d="M414.17 299.55v23.94c0 9.85-7.98 17.83-17.82 17.83h-13.47a17.82 17.82 0 0 1-17.83-17.83v-23.94M267.5 299.55v23.94c0 9.85-7.97 17.83-17.82 17.83h-13.47a17.82 17.82 0 0 1-17.82-17.83v-23.94"
      />
      <path d="M492.17 429.23h-22.32c.9-2.43 1.4-5.05 1.4-7.79v-1.5a7.5 7.5 0 0 0-15 0v1.5a7.5 7.5 0 0 1-7.5 7.5h-129.1V307.05h37.9v16.44a25.35 25.35 0 0 0 25.33 25.33h13.47a25.35 25.35 0 0 0 25.32-25.33v-16.44h27.08a7.5 7.5 0 0 1 7.5 7.5v75.39a7.5 7.5 0 0 0 15 0v-75.39c0-12.4-10.1-22.5-22.5-22.5h-53.31V177.61c0-12.4-10.1-22.5-22.5-22.5h-121.6c-12.4 0-22.5 10.1-22.5 22.5v33.2a7.5 7.5 0 0 0 15 0v-33.2a7.5 7.5 0 0 1 7.5-7.5h28.74v16.44a25.35 25.35 0 0 0 25.32 25.33h13.47a25.35 25.35 0 0 0 25.33-25.33v-16.44h28.74a7.5 7.5 0 0 1 7.5 7.5v114.44l-136.6-.05v-51.19a7.5 7.5 0 0 0-15 0V292h-53.31c-12.4 0-22.5 10.1-22.5 22.5v114.73h-24.24V176.16c34.33-12.54 58.9-45.53 58.9-84.15 0-49.38-40.17-89.55-89.55-89.55S8.6 42.63 8.6 92c0 38.62 24.58 71.6 58.9 84.15V338.8a7.5 7.5 0 0 0 15 0V180.2a89.7 89.7 0 0 0 31.3 0v249.03H82.5V368.8a7.5 7.5 0 0 0-15 0v60.43H19.84A19.85 19.85 0 0 0 0 449.06v9.04c0 10.94 8.9 19.83 19.83 19.83h24.71v9.11c0 12.4 10.1 22.5 22.5 22.5h377.92c12.4 0 22.5-10.1 22.5-22.5v-9.1h24.71c10.94 0 19.83-8.9 19.83-19.84v-9.04c0-10.93-8.9-19.83-19.83-19.83zM329.2 186.55c0 5.7-4.63 10.33-10.33 10.33H305.4c-5.69 0-10.32-4.63-10.32-10.33v-16.44h34.12zm77.47 136.94c0 5.7-4.63 10.33-10.32 10.33h-13.47c-5.7 0-10.33-4.63-10.33-10.33v-16.44h34.12zM23.6 92.01c0-41.1 33.45-74.55 74.55-74.55S172.7 50.9 172.7 92s-33.45 74.55-74.56 74.55S23.6 133.12 23.6 92.01zM225.9 307H260v16.5c0 5.69-4.63 10.32-10.33 10.32h-13.47c-5.7 0-10.32-4.63-10.32-10.33zm-57.86 7.5a7.5 7.5 0 0 1 7.5-7.5h35.36v16.5a25.35 25.35 0 0 0 25.32 25.32h13.47a25.35 25.35 0 0 0 25.33-25.33V307h29.64v122.23H168.03zm284.43 172.54a7.5 7.5 0 0 1-7.5 7.5H67.04a7.5 7.5 0 0 1-7.5-7.5v-9.1h392.92zM497 458.1a4.83 4.83 0 0 1-4.83 4.83H19.83A4.83 4.83 0 0 1 15 458.1v-9.04a4.83 4.83 0 0 1 4.83-4.83h472.34a4.83 4.83 0 0 1 4.83 4.83z" />
      <path d="M98.14 30.19A61.9 61.9 0 0 0 36.32 92c0 34.1 27.73 61.82 61.82 61.82s61.83-27.73 61.83-61.82S132.23 30.2 98.14 30.2zm0 108.64c-25.81 0-46.82-21-46.82-46.82s21-46.82 46.82-46.82 46.83 21 46.83 46.82-21 46.83-46.83 46.83z" />
      <path d="M98.14 63.83a7.5 7.5 0 0 0-7.5 7.5V96a7.5 7.5 0 0 0 15 0V71.32a7.5 7.5 0 0 0-7.5-7.5z" />
    </svg>
  );
}
